<template>
  <div class="content">
    <div class="bodycontent" v-loading="loading">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="180px"
      >
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="功能权限">
          <!-- <span v-if="plugins" style="margin-right:10px">{{plugins}}</span>
          <el-button size="medium" @click="showSelect=true">选择</el-button> -->
          <el-radio-group v-model="plugins">
            <el-radio v-for="item in pluginsList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="formData.des" rows="2" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="保证金数额">
          <el-input v-model="formData.m1" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="费率">
          <el-input v-model="formData.m2" class="input_box"></el-input>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button type="info" class="ml30" @click="goback">返回列表</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showSelect" title="选择功能" width="400px" @close="showSelect=false">
      <el-button v-for="item in pluginsList" :key="item.id" @click="selectPlugin(item)" class="plugin_item">{{item.name}}</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AddMerchType, EditMerchType, GetPluginsList } from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      loading: false,
      formData: {},
      if_add: true,
      showSelect: false,
      plugins: "",
      pluginsList: [],
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    init() {
      this.loading = true;
      
      console.log(this.$route.query);
      var data = "";
      if(this.$route.query.data){ //编辑
        data = this.$route.query.data;
        this.formData = {
          id: data.id,
          pid: data.pid,
          name: data.name,
          des: data.des,
          status: data.status,
        }
        this.if_add = false;
      }else{
        this.formData = {
          pid: "0",
          name: "",
          plugins_id: "",
          des: "",
          status: 1
        };
      }
      if(this.$route.query.pid){ //添加子类
        this.formData.pid = this.$route.query.pid;
      }
      GetPluginsList({token: this.token}).then(res=>{
        if(res.code == 1){
          this.pluginsList = res.data.plugin;
          console.log(this.pluginsList)
          if(data.plugins_id){
            this.plugins = Number(data.plugins_id);
          }else{
            this.plugins = res.data.plugin[0].id
          }
        }else{
          this.$message({
            type:"error",
            message: "网络错误，请稍后重试"
          })
        };
        this.loading = false;
      })
    },
    selectPlugin(item){
      this.formData.plugins_id = item.id;
      this.plugins = item.name;
      this.showSelect = false;
    },
    goback() {
      this.$router.go(-1);
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      data.plugins_id = this.plugins;
      console.log(data);
      this.$refs['formData'].validate(valid => {
        if (valid) {
          if(this.if_add){
            AddMerchType(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: "添加成功"
                });
                this.goback();
              }else{
                this.$message({
                  type: "error",
                  message: res.msg
                })
              }
            });
          }else{
            EditMerchType(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: "修改成功"
                });
                this.goback();
              }else{
                this.$message({
                  type: "error",
                  message: res.msg
                })
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .input_box {
      width: 400px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
  }
  .plugin_item{
    width:100%;
    height: 45px;
    margin: 0;
    margin-bottom: 2px;
  }
}
</style>
